const Component = () => import('./StorefrontConfigPreview');

export { Component };
